module.exports = __webpack_public_path__ + "static/media/ar-deck.63637773.jpg";